import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { ProjectDetails } from '../../../project/gql/generated/ProjectDetails';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type HydrateProjectsQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
  projectIds: Array<Types.Scalars['ID']['input']>;
}>;


export type HydrateProjectsQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, projects: { __typename?: 'ProjectConnection', nodes: Array<{ __typename?: 'Project', id: string, archivedAt?: string | null, description?: string | null, fileCount: number, imageUrl?: string | null, insertedAt: string, isWorkfront?: boolean | null, mountedStorageStatus?: Types.MountedStorageStatus | null, name: string, notificationsEnabled?: boolean | null, private: boolean, rootAssetId: string, storage: number, totalCount?: number | null, updatedAt?: string | null, workfrontProjectLink?: string | null, permissions?: { __typename?: 'ProjectPermissions', canManageResourceControlPolicies: boolean, canDelete: boolean, canUpdate: boolean } | null, images: { __typename?: 'Images', image32?: string | null, image64?: string | null, image128?: string | null, image256?: string | null, imageBase?: string | null, original?: string | null }, workspace?: { __typename?: 'Workspace', id: string, name: string } | null }> } } | null };


export const HydrateProjects = /*#__PURE__*/ gql`
    query HydrateProjects($accountId: ID!, $projectIds: [ID!]!) {
  account(by: {id: $accountId}) {
    id
    projects(filter: {projectIds: $projectIds}, page: {first: 100, mode: CURSOR}) {
      nodes {
        id
        ...ProjectDetails
        permissions {
          canManageResourceControlPolicies
          canDelete
          canUpdate
        }
      }
    }
  }
}
    ${ProjectDetails}` as unknown as DocumentNode<HydrateProjectsQuery, HydrateProjectsQueryVariables>;

          

          export const useHydrateProjectsQuery = (options?:QueryHookOptions<HydrateProjectsQuery, HydrateProjectsQueryVariables>) => useQuery(HydrateProjects, options);

          

          export type HydrateProjectsQueryOptions = QueryHookOptions<HydrateProjectsQuery, HydrateProjectsQueryVariables>;

          

          export const useHydrateProjectsLazyQuery = (options?:LazyQueryHookOptions<HydrateProjectsQuery, HydrateProjectsQueryVariables>) => useLazyQuery(HydrateProjects, options);

          

          export type HydrateProjectsQueryResult = ReturnType<typeof useHydrateProjectsQuery>;

          
